import React, { useState } from 'react';
import { Button, Col, DatePicker, Form, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { SearchOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';
import { disabledSaveBtn } from '../../../../config/Global';
import { validations } from '../../../../config/validations/validations';

const SearchList: React.FC<any> = (props) => {
  const { getList } = props;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);
  const [disabledClear, setDisabledClear] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(true);

  const handleSubmit = (data) => {
    setLoading(true);

    if (data) {
      setLoading(false);
      getList(data);
      setDisabledClear(false);
    }
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        const isDisabled = disabledSaveBtn(form);
        setDisabledSearch(isDisabled);
      })
      .catch((e: any) => {
        setDisabledSearch(true);
        console.warn(e);
      });
  };

  const disabledDate = (current: Dayjs) => {
    // Can not select days after today
    return current && current.isAfter(dayjs().endOf('day'));
  };

  return (
    <FormBox
      className='filterForm'
      form={form}
      onFinish={handleSubmit}
      onChange={handleChange}
      validateTrigger={['onBlur', 'onInput']}
      autoComplete='off'
    >
      <Row gutter={20} align={'middle'}>
        <Col xs={24} md={8}>
          <InputBox.Text
            label='Phone Number'
            name={'phone_number'}
            type='number'
            tooltip='Phone Number must be between 3 to 11 digits and start with 0 or 1.'
            rules={[
              validations.pattern.numericWithSecial,
              validations.pattern.whitespace,
              validations.pattern.phoneNumberValidation,
            ]}
          />
        </Col>
        <Col xs={24} md={8}>
          <InputBox.Select
            label='Number Type'
            name={'number_type'}
            allowClear
            showSearch
            placeholder='Select Number Type'
            tooltip='Select Number Type'
            options={{
              list: [
                {
                  id: 'mobile',
                  label: 'Mobile',
                },
                {
                  id: 'fixed',
                  label: 'Fixed',
                },
                {
                  id: 'both',
                  label: 'Both',
                },
              ],
              valueKey: 'id',
              textKey: 'label',
            }}
            onChange={handleChange}
          />
        </Col>

        <Col xs={24} md={8}>
          <InputBox.Select
            label='State'
            name='state'
            allowClear
            showSearch
            placeholder='Select State'
            tooltip='Select State'
            onChange={handleChange}
            options={{
              list: [
                { id: 'available', label: 'Available' },
                { id: 'in use for client', label: 'In Use for Client' },
                { id: 'in use internal', label: 'In Use Internal' },
                { id: 'reserved for client', label: 'Reserved for Client' },
                { id: 'freezed by client', label: 'Freezed by Client' },
                { id: 'freezed account', label: 'Freezed Account' },
                { id: 'ported', label: 'Ported' },
              ],
              valueKey: 'id',
              textKey: 'label',
            }}
          />
        </Col>
        <Col xs={24} md={8}>
          <InputBox.Select
            label='Payment Type'
            name='payment_type'
            allowClear
            showSearch
            placeholder='Select Payment Type'
            tooltip='Select Payment Type'
            options={{
              list: [
                { id: 'prepaid', label: 'Prepaid' },
                { id: 'postpaid', label: 'Postpaid' },
              ],
              valueKey: 'id',
              textKey: 'label',
            }}
            onChange={handleChange}
          />
        </Col>
        <Col xs={24} md={8}>
          <InputBox.Select
            label='Service Type'
            name='service_type'
            allowClear
            showSearch
            placeholder='Select Service Type'
            tooltip='Select Service Type'
            options={{
              list: [
                { id: 'M2M/IoT', label: 'M2M/IoT' },
                { id: 'regular', label: 'Regular' },
                { id: 'kosher', label: 'Kosher' },
                { id: 'data only', label: 'Data Only' },
                { id: 'irrelevant', label: 'Irrelevant' },
              ],
              valueKey: 'id',
              textKey: 'label',
            }}
            onChange={handleChange}
          />
        </Col>
        <Col xs={24} md={8}>
          <InputBox.Select
            label='Subscription Type'
            name='subscription_type'
            allowClear
            showSearch
            placeholder='Select Subscription Type'
            tooltip='Select Subscription Type'
            options={{
              list: [
                { id: 'business', label: 'Business' },
                { id: 'private', label: 'Private' },
                { id: 'splitted business', label: 'Splitted Business' },
                { id: 'irrelevant', label: 'Irrelevant' },
              ],
              valueKey: 'id',
              textKey: 'label',
            }}
            onChange={handleChange}
          />
        </Col>
        <Col xs={12} md={12} lg={6} xl={3}>
          <Button
            type='primary'
            htmlType='submit'
            loading={loading}
            disabled={disabledSearch}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col xs={12} md={12} lg={6} xl={3}>
          <Button
            type='default'
            htmlType='reset'
            disabled={disabledClear}
            onClick={() => {
              getList();
              form.resetFields();
              setDisabledSearch(true);
              setDisabledClear(true);
            }}
          >
            Clear
          </Button>
        </Col>
      </Row>
    </FormBox>
  );
};

export default SearchList;
